import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

interface secondaryDietType {
    secondaryDietTypeName: any;
    id: number;
    imageUrl: any;
    isActive: boolean
}

interface dietState {
    data: secondaryDietType[];
    loading: boolean;
    error: string | null;
}

const PORT = import.meta.env.VITE_COOK_PORT;
const MASTERURL = import.meta.env.VITE_API_COOK_URL;

interface ApiResponse {
    data: secondaryDietType[];
}

export const fetchSecondaryDietType = createAsyncThunk<secondaryDietType[], void, { rejectValue: string }>(
    'dietSecondaryType/fetchSecondaryDietType',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.get<ApiResponse>('/get_all_secondary_diet_types', PORT, MASTERURL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);
export const createSecondaryDietType: any = createAsyncThunk(
    'dietType/createdietType', async (params: any, thunkAPI) => {
        try {
            const response = await apiService.post('create_secondary_diet_type', params, PORT, MASTERURL);
            console.log(response)
            return response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

export const updateSecondaryDietType: any = createAsyncThunk(
    'dietType/updatedietType',
    async (params: any, thunkAPI) => {
        console.log(params)
        try {
            const response = await apiService.put('update_secondary_diet_type', params, PORT, MASTERURL);
            console.log(response)
            return response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

export const deleteSecondaryDietType = createAsyncThunk<
    { id: number }, // return type
    number,          // argument type
    { rejectValue: string } // reject type
>(
    "dietType/deleteSecondaryDietType",
    async (id, { rejectWithValue }) => {
        try {
            const response = await apiService.patch<{ data: { id: number } }>(
                `/soft_delete_secondary_diet_type?id=${id}`,
                {},
                PORT,
                MASTERURL
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred while deleting pack unit');
        }
    }
);

export const secondaryDietSlice = createSlice({
    name: 'dietType',
    initialState: {
        data: [] as secondaryDietType[],
        loading: false,
        error: null,
    } as dietState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSecondaryDietType.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSecondaryDietType.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchSecondaryDietType.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
    },
});

export default secondaryDietSlice.reducer;